<template>
  <warehouse-home config-module="320005" lob="AI" />
</template>

<script>
import WarehouseHome from '@/components/Cargo/Warehouse/warehouseHome'
export default {
  name: 'AIWarehouseModule',
  components: { WarehouseHome }
}
</script>

<style scoped>

</style>
